var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        "class-name": "create-new-plan",
        title: _vm.form._id ? "Plan Güncelle" : "Plan Oluştur",
        "show-footer": false,
      },
      on: { cancel: _vm.cancelAction },
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex flex-column",
          staticStyle: {
            overflow: "scroll",
            height: "60vh",
            "padding-right": "5px",
            "padding-bottom": "15px",
          },
        },
        [
          _vm.form.type !== "feature"
            ? _c(
                "div",
                [
                  _c("div", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("Settings"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-checkbox",
                    {
                      model: {
                        value: _vm.form.isFreePlan,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isFreePlan", $$v)
                        },
                        expression: "form.isFreePlan",
                      },
                    },
                    [_vm._v("Ücretsiz Paket")]
                  ),
                  _vm._v(" "),
                  !_vm.form.isFreePlan
                    ? _c(
                        "a-checkbox",
                        {
                          model: {
                            value: _vm.form.isOnDemand,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "isOnDemand", $$v)
                            },
                            expression: "form.isOnDemand",
                          },
                        },
                        [_vm._v("Anlık Ücret Alınacak ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.form.isFreePlan
                    ? _c(
                        "a-checkbox",
                        {
                          model: {
                            value: _vm.form.isTeamPlan,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "isTeamPlan", $$v)
                            },
                            expression: "form.isTeamPlan",
                          },
                        },
                        [_vm._v("Takım Planı ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.form.isFreePlan
                    ? _c(
                        "a-checkbox",
                        {
                          model: {
                            value: _vm.form.isAppsumo,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "isAppsumo", $$v)
                            },
                            expression: "form.isAppsumo",
                          },
                        },
                        [_vm._v("Appsumo Paketi")]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("div", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v("Plan Sırası"),
              ]),
              _vm._v(" "),
              _c("a-input", {
                staticClass: "plan-input",
                attrs: { min: 0, type: "number" },
                model: {
                  value: _vm.form.order,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "order", $$v)
                  },
                  expression: "form.order",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.isAppsumo
            ? _c(
                "div",
                [
                  _c("div", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("Gerekli Kod Sayısı"),
                  ]),
                  _vm._v(" "),
                  _c("a-input", {
                    staticClass: "plan-input",
                    attrs: { min: 0, type: "number" },
                    model: {
                      value: _vm.form.requiredCodes,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "requiredCodes", $$v)
                      },
                      expression: "form.requiredCodes",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("div", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v("Başlık"),
              ]),
              _vm._v(" "),
              _c("a-input", {
                staticClass: "plan-input",
                attrs: { type: "text" },
                model: {
                  value: _vm.form.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "title", $$v)
                  },
                  expression: "form.title",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("div", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v("Alt Başlık"),
              ]),
              _vm._v(" "),
              _c("a-input", {
                staticClass: "plan-input",
                attrs: { type: "text" },
                model: {
                  value: _vm.form.altTitle,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "altTitle", $$v)
                  },
                  expression: "form.altTitle",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("div", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v("Paket Türü"),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  model: {
                    value: _vm.form.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "type", $$v)
                    },
                    expression: "form.type",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "supsis" } }, [
                    _vm._v(" Supsis"),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "whatsapp" } }, [
                    _vm._v(" Whatsapp"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-select-option",
                    { attrs: { value: "whatsapp-business" } },
                    [_vm._v(" Whatsapp Business")]
                  ),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "chatbot" } }, [
                    _vm._v(" Chatbot"),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "instagram" } }, [
                    _vm._v(" Instagram"),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "messenger" } }, [
                    _vm._v(" Messenger"),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "telegram" } }, [
                    _vm._v(" Telegram"),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "feature" } }, [
                    _vm._v(" Özellik"),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "custom" } }, [
                    _vm._v(" Custom"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.type === "custom" || _vm.form.type === "feature"
            ? _c(
                "div",
                { staticStyle: { "margin-top": "15px" } },
                [
                  _c("div", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.form.type === "custom"
                            ? "Custom Paket Key"
                            : "Özellik Anahtarı"
                        ) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("a-input", {
                    staticClass: "plan-input",
                    attrs: { type: "text", placeholder: "whatsapp-broadcast" },
                    model: {
                      value: _vm.form.dynamicType,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "dynamicType", $$v)
                      },
                      expression: "form.dynamicType",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "15px" } },
            [
              _c("div", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v("Customer Key"),
              ]),
              _vm._v(" "),
              _c("a-input", {
                staticClass: "plan-input",
                attrs: { type: "text", placeholder: "appsumo" },
                model: {
                  value: _vm.form.partnerKey,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "partnerKey", $$v)
                  },
                  expression: "form.partnerKey",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.form.isFreePlan
            ? _c(
                "div",
                { staticStyle: { "margin-top": "15px" } },
                [
                  _c("div", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("Aylık Fiyat"),
                  ]),
                  _vm._v(" "),
                  _c("a-input", {
                    staticClass: "plan-input",
                    attrs: { min: 0, type: "number" },
                    model: {
                      value: _vm.form.price,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "price", $$v)
                      },
                      expression: "form.price",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.form.isFreePlan
            ? _c(
                "div",
                { staticStyle: { "margin-top": "15px" } },
                [
                  _c("div", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("Aylık İndirimsiz Fiyat (İşlevsiz Göstermelik)"),
                  ]),
                  _vm._v(" "),
                  _c("a-input", {
                    staticClass: "plan-input",
                    attrs: { min: 0, type: "number" },
                    model: {
                      value: _vm.form.discountPrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "discountPrice", $$v)
                      },
                      expression: "form.discountPrice",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.form.isFreePlan
            ? _c(
                "div",
                { staticStyle: { "margin-top": "5px" } },
                [
                  _c("div", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("2 Yıllık İndirim"),
                  ]),
                  _vm._v(" "),
                  _c("a-input", {
                    staticClass: "plan-input",
                    attrs: { min: 0, type: "number" },
                    model: {
                      value: _vm.form.twoYearDiscount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "twoYearDiscount", $$v)
                      },
                      expression: "form.twoYearDiscount",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.form.isFreePlan
            ? _c(
                "div",
                { staticStyle: { "margin-top": "5px" } },
                [
                  _c("div", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("Yıllık İndirim"),
                  ]),
                  _vm._v(" "),
                  _c("a-input", {
                    staticClass: "plan-input",
                    attrs: { min: 0, type: "number" },
                    model: {
                      value: _vm.form.yearlyDiscount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "yearlyDiscount", $$v)
                      },
                      expression: "form.yearlyDiscount",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.form.isFreePlan
            ? _c(
                "div",
                { staticStyle: { "margin-top": "5px" } },
                [
                  _c("div", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("6 Aylık İndirim"),
                  ]),
                  _vm._v(" "),
                  _c("a-input", {
                    staticClass: "plan-input",
                    attrs: { min: 0, type: "number" },
                    model: {
                      value: _vm.form.sixMonthlyDiscount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sixMonthlyDiscount", $$v)
                      },
                      expression: "form.sixMonthlyDiscount",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.form.isFreePlan
            ? _c(
                "div",
                { staticStyle: { "margin-top": "5px" } },
                [
                  _c("div", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v("3 Aylık İndirim"),
                  ]),
                  _vm._v(" "),
                  _c("a-input", {
                    staticClass: "plan-input",
                    attrs: { min: 0, type: "number" },
                    model: {
                      value: _vm.form.threeMonthlyDiscount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "threeMonthlyDiscount", $$v)
                      },
                      expression: "form.threeMonthlyDiscount",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-top": "5px" } }, [
            _c("div", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v("Features"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { width: "100%" } },
              [
                _c(
                  "a-select",
                  {
                    staticStyle: { width: "100%" },
                    on: { select: _vm.onSelectFeaturesForm },
                    model: {
                      value: _vm.featuresForm,
                      callback: function ($$v) {
                        _vm.featuresForm = $$v
                      },
                      expression: "featuresForm",
                    },
                  },
                  [
                    _c("a-select-option", { attrs: { value: "agent" } }, [
                      _vm._v("Agent"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "archive" } }, [
                      _vm._v("Archive"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "chat" } }, [
                      _vm._v("Chat"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "chatbot" } }, [
                      _vm._v("Chatbot"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "mail" } }, [
                      _vm._v("Mail"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "report" } }, [
                      _vm._v("Report"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "sms" } }, [
                      _vm._v("SMS"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "support" } }, [
                      _vm._v("Support"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "system" } }, [
                      _vm._v("System"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "team_chat" } }, [
                      _vm._v("Team Chat"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "triggers" } }, [
                      _vm._v("Triggers"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "whatsapp" } }, [
                      _vm._v("Whatsapp"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "instagram" } }, [
                      _vm._v("Instagram"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "messenger" } }, [
                      _vm._v("Messenger"),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "services" } }, [
                      _vm._v("Services"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "10px" } },
                  [
                    _vm.features.includes("agent")
                      ? _c("AgentFeature", {
                          on: {
                            close: function ($event) {
                              return _vm.deleteFeature("agent")
                            },
                          },
                          model: {
                            value: _vm.form,
                            callback: function ($$v) {
                              _vm.form = $$v
                            },
                            expression: "form",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.features.includes("archive")
                      ? _c("ArchiveFeature", {
                          on: {
                            close: function ($event) {
                              return _vm.deleteFeature("archive")
                            },
                          },
                          model: {
                            value: _vm.form,
                            callback: function ($$v) {
                              _vm.form = $$v
                            },
                            expression: "form",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.features.includes("chat")
                      ? _c("ChatFeature", {
                          on: {
                            close: function ($event) {
                              return _vm.deleteFeature("chat")
                            },
                          },
                          model: {
                            value: _vm.form,
                            callback: function ($$v) {
                              _vm.form = $$v
                            },
                            expression: "form",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.features.includes("chatbot")
                      ? _c("ChatBotFeature", {
                          on: {
                            close: function ($event) {
                              return _vm.deleteFeature("chatbot")
                            },
                          },
                          model: {
                            value: _vm.form,
                            callback: function ($$v) {
                              _vm.form = $$v
                            },
                            expression: "form",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.features.includes("mail")
                      ? _c("MailFeature", {
                          on: {
                            close: function ($event) {
                              return _vm.deleteFeature("mail")
                            },
                          },
                          model: {
                            value: _vm.form,
                            callback: function ($$v) {
                              _vm.form = $$v
                            },
                            expression: "form",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.features.includes("report")
                      ? _c("ReportFeature", {
                          on: {
                            close: function ($event) {
                              return _vm.deleteFeature("report")
                            },
                          },
                          model: {
                            value: _vm.form,
                            callback: function ($$v) {
                              _vm.form = $$v
                            },
                            expression: "form",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.features.includes("sms")
                      ? _c("SMSFeature", {
                          on: {
                            close: function ($event) {
                              return _vm.deleteFeature("sms")
                            },
                          },
                          model: {
                            value: _vm.form,
                            callback: function ($$v) {
                              _vm.form = $$v
                            },
                            expression: "form",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.features.includes("support")
                      ? _c("SupportFeature", {
                          on: {
                            close: function ($event) {
                              return _vm.deleteFeature("support")
                            },
                          },
                          model: {
                            value: _vm.form,
                            callback: function ($$v) {
                              _vm.form = $$v
                            },
                            expression: "form",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.features.includes("system")
                      ? _c("SystemFeature", {
                          on: {
                            close: function ($event) {
                              return _vm.deleteFeature("system")
                            },
                          },
                          model: {
                            value: _vm.form,
                            callback: function ($$v) {
                              _vm.form = $$v
                            },
                            expression: "form",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.features.includes("team_chat")
                      ? _c("TeamChatFeature", {
                          on: {
                            close: function ($event) {
                              return _vm.deleteFeature("team_chat")
                            },
                          },
                          model: {
                            value: _vm.form,
                            callback: function ($$v) {
                              _vm.form = $$v
                            },
                            expression: "form",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.features.includes("triggers")
                      ? _c("TriggerFeature", {
                          on: {
                            close: function ($event) {
                              return _vm.deleteFeature("triggers")
                            },
                          },
                          model: {
                            value: _vm.form,
                            callback: function ($$v) {
                              _vm.form = $$v
                            },
                            expression: "form",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.features.includes("whatsapp")
                      ? _c("WhatsappFeature", {
                          on: {
                            close: function ($event) {
                              return _vm.deleteFeature("whatsapp")
                            },
                          },
                          model: {
                            value: _vm.form,
                            callback: function ($$v) {
                              _vm.form = $$v
                            },
                            expression: "form",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.features.includes("instagram")
                      ? _c("InstagramFeature", {
                          on: {
                            close: function ($event) {
                              return _vm.deleteFeature("instagram")
                            },
                          },
                          model: {
                            value: _vm.form,
                            callback: function ($$v) {
                              _vm.form = $$v
                            },
                            expression: "form",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.features.includes("messenger")
                      ? _c("MessengerFeature", {
                          on: {
                            close: function ($event) {
                              return _vm.deleteFeature("messenger")
                            },
                          },
                          model: {
                            value: _vm.form,
                            callback: function ($$v) {
                              _vm.form = $$v
                            },
                            expression: "form",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.features.includes("services")
                      ? _c("ServicesFeature", {
                          on: {
                            close: function ($event) {
                              return _vm.deleteFeature("services")
                            },
                          },
                          model: {
                            value: _vm.form,
                            callback: function ($$v) {
                              _vm.form = $$v
                            },
                            expression: "form",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.form._id
        ? _c(
            "b-button",
            {
              staticStyle: { "margin-top": "10px" },
              attrs: { size: "sm", variant: "success" },
              on: { click: _vm.updateAction },
            },
            [_vm._v("\n        " + _vm._s(_vm.$t("message.update")) + "\n    ")]
          )
        : _c(
            "b-button",
            {
              staticStyle: { "margin-top": "10px" },
              attrs: { size: "sm", variant: "success" },
              on: { click: _vm.createAction },
            },
            [_vm._v("\n        " + _vm._s(_vm.$t("message.save")) + "\n    ")]
          ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticStyle: { "margin-top": "2px" },
          attrs: { size: "sm", variant: "error" },
          on: { click: _vm.cancelAction },
        },
        [_vm._v(" İptal Et")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }